var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-dialog',{class:_vm.$style.dialog,attrs:{"width":"80rem","show-close":"","close-on-press-escape":false,"close-on-click-modal":false},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('app-contact-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }